import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M5.554 13.819a3.694 3.694 0 0 0 1.458-.702 4.083 4.083 0 1 0 5.404-6.075l.179-.205a3.13 3.13 0 1 0-4.723-4.11L2.664 8.712a3.13 3.13 0 0 0 .306 4.416c.798.694 1.718.88 2.584.691Zm5.75-10.267a1.63 1.63 0 0 0-2.3.16L7.016 5.996c.24.387.467.695.7.951a4.091 4.091 0 0 1 3.292-.572l.455-.523a1.63 1.63 0 0 0-.16-2.3Zm-5.312 3.62c.209.305.424.58.655.83a4.065 4.065 0 0 0-.731 2.331c0 .533.102 1.042.288 1.509-.31.264-.647.441-.97.512-.415.09-.848.018-1.28-.357a1.63 1.63 0 0 1-.159-2.3l2.197-2.525Zm1.814 4.526a2.583 2.583 0 0 0 4.776-1.28l-4.776 1.28Zm4.388-2.729a2.585 2.585 0 0 0-4.776 1.28l4.776-1.28Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  a
];
function n(r, d) {
  return e(), t("svg", o, [...c]);
}
const m = { render: n };
export {
  m as default,
  n as render
};
